import {
  ImportedNgModuleProviders,
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import {
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_ENTITY_SERVICE,
  SoftlineEntityService,
  Store,
  StoreModule,
} from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import {
  ApplicationStore,
  getModuleGroupByName,
  SOFTLINE_CONFIG_OFFLINE_FEATURE,
  SOFTLINE_FEATURE_APPLICATIONS,
} from '@softline/application';
import { default as de } from '../i18n/de.json';
import {
  SOFTLINE_FEATURE_KOMMISSIONIERUNG,
  SOFTLINE_PERMISSION_KOMMISSIONIERUNG,
  SOFTLINE_PERMISSION_VORKOMMISSIONIERUNG,
} from './kommissionierung.shared';
import { KommissionierungStore } from './store';
import { SOFTLINE_API_KOPFKOMM } from './kommissionierung.api';
import { provideSoftAppsModule, withSoftAppsModuleRoutes } from '@softapps/core';
import { vorKommissionierungRoutes } from './kommissionierung.routes';

export const kommissionierungProviders: (Provider | ImportedNgModuleProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'kommissionierung',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#KOMMISSIONIERUNG.APP',
      description: '#KOMMISSIONIERUNG.APP_DESC',
      route: '/kommissionierung',
      icon: 'fa-regular fa-cart-flatbed-boxes',
      permission: SOFTLINE_PERMISSION_KOMMISSIONIERUNG,
      group: getModuleGroupByName('Lager'),
    });
  }),
  importProvidersFrom(
    StoreModule.forFeature({
      name: SOFTLINE_FEATURE_KOMMISSIONIERUNG,
      feature: KommissionierungStore.feature,
      providers: [
        {
          provide: SOFTLINE_STORE_ENTITY_SERVICE,
          useFactory: (service) =>
            new SoftlineEntityService(service, SOFTLINE_API_KOPFKOMM),
          deps: [SOFTLINE_SERVICE_HTTP],
        },
      ],
    })
  ),
  {
    provide: SOFTLINE_CONFIG_OFFLINE_FEATURE,
    useValue: { featureName: SOFTLINE_FEATURE_KOMMISSIONIERUNG, fields: ['query'] },
    multi: true,
  },
];

// kommissionierungProviders are required!!!
// otherwise it won't work as there are missing providers
// this was a quick-fix for Holz-Braun...
export function provideVorKommissionierung() {
  return [
    provideSoftAppsModule(
      {
        name: 'vorkommissionierung',
        title: 'Vor-Kommissionierung',
        route: '/vorkommissionierung',
        icon: 'fa-regular fa-cart-flatbed',
        permission: SOFTLINE_PERMISSION_VORKOMMISSIONIERUNG,
      },
      withSoftAppsModuleRoutes({ app: vorKommissionierungRoutes })
    ),
  ];
}
